import axios from "axios";

export const getAccessKey = (target, period) => {
  const requestUrl = `/data/access-key`;

  let params = {
    target: target,
    period: period
  };

  return axios.get(requestUrl, {
    params
  });
};

export const generatePresentationAccessKey = ({ target, expires, period }) => {
  const requestUrl = `/data/access-key/generate`;

  let formData = new FormData();
  formData.append("target", target);
  formData.append("expires", expires);
  formData.append("period", period);

  return axios.post(requestUrl, formData);
};

export const verifyAccessKey = (target, accessKey) => {
  const requestUrl = `/data/access-key/verify`;

  let formData = new FormData();
  formData.append("target", target);
  formData.append("accessKey", accessKey);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/access-key.js